export default "__VITE_ASSET__Drm5IwVe__"